import styled, { css } from 'styled-components';
import Title from 'desktop/components/Title';
import Text from 'desktop/components/Text';
import Icon from 'desktop/components/Icon';
import { colorVariables } from 'desktop/theme/variables';
import { ReactComponent as LockSprite } from 'assets/icons/lock.svg';

export const ChannelStyled = styled.div`
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  height: 35px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:last-child {
    margin-bottom: 15px;
  }

  ${(props) =>
    props.active &&
    css`
      ${LockIcon} {
        fill: ${colorVariables.orange};
      }
      ${StyledTitle} {
        color: ${colorVariables.orange};
      }
      ${StyledText} {
        color: ${colorVariables.orange};
      }
    `};
`;

export const ImageWrap = styled.div`
  position: relative;
  width: 35px;
  height: 35px;
  margin-right: 10px;
  background-color: ${colorVariables.gray_nightrider};
`;

export const Image = styled.img.attrs({
  src: (props) => props.src,
  alt: '',
})`
  max-width: 100%;
  height: 100%;
  ${(props) =>
    props.load
      ? css`
          opacity: 1;
          visibility: visible;
        `
      : css`
          opacity: 0;
          visibility: hidden;
        `};
  transition: opacity 0.25s ease-in;
`;

export const PlayWrap = styled.div`
  position: absolute;
  width: 35px;
  height: 35px;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 135ms ease-in;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${ChannelStyled}:hover & {
    opacity: 1;
    transition: 135ms ease-out;
  }
`;

export const Description = styled.div`
  position: relative;
  width: calc(100% - 45px);
`;

export const TitleWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-right: 40px;
  margin: 0 0 2px;
`;

export const TextWrap = styled.div`
  position: relative;
  padding-right: 30px;
`;

export const RecordWrap = styled.div`
  position: relative;
  margin-left: 5px;
  transform: translate(0, -1px);
  font-size: 0;
`;

export const StyledText = styled(Text)`
  && {
    opacity: 0.75;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    ${ChannelStyled}:hover & {
      color: ${colorVariables.fire};
      transition: 135ms ease-out;
    }
  }
`;

export const StyledTitle = styled(Title)`
  && {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    ${ChannelStyled}:hover & {
      color: ${colorVariables.fire};
      transition: 135ms ease-out;
    }
  }
`;

export const StyledIcon = styled(Icon)`
  && {
    ${ChannelStyled}:hover & {
      fill: ${colorVariables.fire};
      transition: 135ms ease-out;
    }
  }
`;

export const LockIcon = styled(LockSprite)`
  && {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translate(0, -50%);
    ${(props) => `
      width: ${props.size}px;
      height: ${props.size}px;
      fill: ${colorVariables[props.color]};
    `}
    
    ${ChannelStyled}:hover & {
      fill: ${colorVariables.fire};
      transition: 135ms ease-out;
    }
  }
`;
